import { render, staticRenderFns } from "./examInvoiceAccept.vue?vue&type=template&id=6225836c"
import script from "./examInvoiceAccept.vue?vue&type=script&lang=js"
export * from "./examInvoiceAccept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports